import { Component, Input, Output, EventEmitter, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'ecoupon-shared-ui-lib-dialog-announce',
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './lib-dialog-announce.component.html',
  styleUrl: './lib-dialog-announce.component.scss',
})
export class LibDialogAnnounceComponent {
  @Input() set open(value: boolean) {
    this.isOpen.set(value);
  }
  @Input() title = '';
  @Input() message = '';

  @Output() closed = new EventEmitter<void>();

  isOpen = signal<boolean>(false);

  close(): void {
    this.isOpen.set(false);
    this.closed.emit();
  }
}
